import { Injectable } from '@angular/core';
import { initializeAdditionalBites, ScanOptionsStore } from '@modules/scan-options/state/scan-options-store';
import { TeethDiagramStore } from '@modules/teeth-diagram/state/teeth-diagram-store';
import { TeethDiagramQuery } from '@modules/teeth-diagram/state/teeth-diagram-query';
import { RxIntuitiveTeethDiagramStore } from '@modules/rx-intuitive-teeth-orchestrator/state/rx-intuitive-teeth-diagram-store';
import { ShellStore } from '@shared/store/shell/shell-store';

/**
 * Centralized service for resetting RX-related stores.
 * Use when procedure or send-to changes require clearing dependent state.
 */
@Injectable()
export class RxIntuitiveStoresResetService {
	constructor(
		private readonly teethDiagramStore: TeethDiagramStore,
		private readonly teethDiagramQuery: TeethDiagramQuery,
		private readonly shellStore: ShellStore,
		private readonly intuitiveDiagramStore: RxIntuitiveTeethDiagramStore,
		private readonly scanOptionsStore: ScanOptionsStore
	) {}

	/**
	 * Resets teeth diagram, sets procedure-changed flag, and deselects bridge.
	 * After resetting the store, the DirtyCheckPlugin baseline must be rebased so
	 * a subsequent send-to change does not see the reset as new unsaved work.
	 */
	resetDependingStores(): void {
		this.teethDiagramStore.resetTeeth();
		this.teethDiagramQuery.resetDirtyCheckHead();
		this.shellStore.updateProcedureChangedFlag(true);
		this.intuitiveDiagramStore.reset();
	}

	/**
	 * Clears the restorative multi-bite toggle and all selected bites.
	 * Call when switching to a lab whose template disables the multi-bite toggle.
	 */
	resetRestoMultiBite(): void {
		this.scanOptionsStore.update({
			isRestoMultiBiteSelected: false,
			additionalBites: initializeAdditionalBites()
		});
	}
}
